export const useDateFormatter = (value: Date, format?: string) => {
  function pad(s: number) {
    return s < 10 ? '0' + s : s
  }

  if (!value) return

  var d = new Date(value)

  if (format === 'MM-DD-YYYY') {
    return (
      pad(d.getMonth() + 1) + '/' + d.getDate() + '/' + d.getFullYear()
    )
  } else {
    return (
      pad(d.getMonth() + 1) +
      '/' +
      pad(d.getDate()) +
      '/' +
      d.getFullYear() +
      ' ' +
      pad(d.getHours()) +
      ':' +
      pad(d.getMinutes() + 1) +
      ':' +
      pad(d.getSeconds() + 1)
    )
  }
}
